import { makeStyles } from '@mui/styles';
import { qrReaderMaskLeftRightWidth, qrReaderMaskTopBottomHeight } from "../constants";
import colors from "../../../common/styles/colors";

export default makeStyles({
  container: (props: { shouldUpdateStyles?: boolean }) => ({
    display: props.shouldUpdateStyles ? "flex" : "block",
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
    height: "100%",
    position: "absolute",
    top: 0,
    left: 0,
    zIndex: 10000,
    "@media screen and (max-width: 447px)": {
      width: "100vw",
      left: "calc((100% - 100vw) / 2)"
    }
  }),
  readerMaskTopBottom: (props: { shouldUpdateStyles?: boolean }) => ({
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    opacity: props.shouldUpdateStyles ? 1 : 0.5,
    borderRadius: 15,
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    flexDirection: "column",
    "&::before": {
      borderRadius: props.shouldUpdateStyles ? '0' : "15px 15px 0 0",
      content: "''",
      width: "100%",
      height: qrReaderMaskTopBottomHeight,
      backgroundColor: props.shouldUpdateStyles ? colors.lightGrey1 : colors.black,
      "@media screen and (max-width: 447px)": {
        borderRadius: 0
      },
      opacity: props.shouldUpdateStyles ? 1 : 0.6
    },
    "&::after": {
      content: "''",
      width: "100%",
      height: qrReaderMaskTopBottomHeight,
      backgroundColor: props.shouldUpdateStyles ? colors.lightGrey1 : colors.black,
      opacity: props.shouldUpdateStyles ? 1 : 0.6,
      "@media screen and (max-width: 447px)": {
        borderRadius: 0
      },
      borderRadius: props.shouldUpdateStyles ? '0' : "0 0 15px 15px"
    }
  }),
  readerMaskLeftRight: (props: { shouldUpdateStyles?: boolean }) => ({
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    opacity: props.shouldUpdateStyles ? 1 : 0.6,
    borderRadius: 15,
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    "&::before": {
      content: "''",
      width: qrReaderMaskLeftRightWidth,
      height: `calc(100% - ${qrReaderMaskTopBottomHeight} * 2)`,
      "@media screen and (max-width: 568px)": {
        width: "calc((100% - 60vw) / 2)"
      },
      backgroundColor: props.shouldUpdateStyles ? colors.lightGrey1 : colors.black,
      opacity: props.shouldUpdateStyles ? 1 : 0.6
    },
    "&::after": {
      content: "''",
      width: qrReaderMaskLeftRightWidth,
      height: `calc(100% - ${qrReaderMaskTopBottomHeight} * 2)`,
      "@media screen and (max-width: 568px)": {
        width: "calc((100% - 60vw) / 2)"
      },
      backgroundColor: props.shouldUpdateStyles ? colors.lightGrey1 : colors.black,
      opacity: props.shouldUpdateStyles ? 1 : 0.6
    }
  }),
  readerMaskLeftRightFullscreen: {
    "&::before": {
      width: "50%"
    },
    "&::after": {
      width: "50%"
    }
  }
});
